/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Passwordplaceholder1Inputs */

const zh_auth_passwordplaceholder1 = /** @type {(inputs: Auth_Passwordplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入密码`)
};

const en_auth_passwordplaceholder1 = /** @type {(inputs: Auth_Passwordplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your password`)
};

const es_auth_passwordplaceholder1 = /** @type {(inputs: Auth_Passwordplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa tu contraseña`)
};

/**
* | output |
* | --- |
* | "Enter your password" |
*
* @param {Auth_Passwordplaceholder1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_passwordplaceholder1 = /** @type {((inputs?: Auth_Passwordplaceholder1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Passwordplaceholder1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_passwordplaceholder1(inputs)
	if (locale === "en") return en_auth_passwordplaceholder1(inputs)
	return es_auth_passwordplaceholder1(inputs)
});
export { auth_passwordplaceholder1 as "auth_passwordPlaceholder" }